import { Button } from "antd";
import PageMarketing from "../../../../../../../admin/page/PageMarketing";

import StyledModal from "./style";

import Close from "../../../../../../../../../../image/icon/Close";

const ModalViewFolders = ({ marketingMaterialsData, onCancel, open }) => {
  return (
    <StyledModal
      closeIcon={<Close />}
      footer={
        <Button onClick={onCancel} shape="round">
          Close
        </Button>
      }
      onCancel={onCancel}
      open={open}
      title="Folders"
      width={1100}
    >
      <PageMarketing
        marketingMaterialsData={marketingMaterialsData}
        viewReadonly
      />
    </StyledModal>
  );
};

export default ModalViewFolders;
